export const IOS_APP_STORE_URL =
  "https://apps.apple.com/gb/app/22night/id6762454252";
